module.exports = __webpack_public_path__ + "img/MITSUBISHI.552a53e.jpg";